module.exports = __webpack_public_path__ + "static/img/grooming.ba523cac.jpg";